<template>
  <div class="appendix">
    <div style="height: calc(100% - 80px);" :key="pdfUrl">
      <PdfViewer :loaded="loaded" :readComplete="readComplete" :url="pdfUrl" />
    </div>
    <div style="width: 100%;text-align: center;">
      <van-checkbox
        style="margin-left: 20px;"
        name="是"
        shape="square"
        v-model="isAccept"
      ><div style="padding: 10px; text-align: left;">
      I certify that I have the capacity to sign for the person identified on line 1 of this form</div></van-checkbox>
      <van-button type="primary" class="btn" @click="before" :disabled="isDisabled || !isAccept">
        我已认真阅读
      </van-button>
    </div>
  </div>
</template>

<script>
import { Button, Checkbox, Toast } from 'vant';
import httpApi from '../../utils/httpApi';
import text from './text';
import PdfViewer from "../../components/PdfViewer.vue";

export default {
  name: 'appendix',
  components: {
    [Button.name]: Button,
    PdfViewer,
    [Checkbox.name]: Checkbox,
  },
  data() {
    return {
      isAccept: false,
      isLoaded: false,
      isDisabled: true,
      content: text.stock,
      submitForm: {},
      pdfUrl: 'https://forexmaster.oss-cn-beijing.aliyuncs.com/openAccount/fw8ben_version_2021.pdf',
    };
  },
  methods: {
    // PDF加载完成
    loaded() {
      this.isLoaded = true;
      Toast.clear();
    },
    // PDF阅读完成
    readComplete() {
      if (this.submitForm.wben !== '是') {
        this.isDisabled = false;
      }
    },
    async before() {
      const res = await this.$api.postChooseStepOne({
        ...this.submitForm,
        wben: '是',
      });
      if (res) {
        this.$router.back();
      }
    },
  },
  async mounted() {
    this.$store.commit('setStepsShow', false);
    this.$store.commit('setTitleValue', 'Form W-8BEN（Rev. October 2021）');
    const result = await httpApi.getChooseStepOne();
    const { data } = result;
    this.submitForm = data;
    if (!this.isLoaded) {
      Toast.loading({
        message: "文件加载中...",
        duration: 0,
        overlay: true
      });
    }
    this.isAccept = !!(data.wben === '是');
  },
};

</script>

<style lang="less">
.appendix {
  text-align: left;
  height: 100%;

  .content {
    padding: @space-2;
    background: @contentColor;
    font-size: @font-size-2;
  }

  .btn {
    width: 80%;
    margin: @space-0 auto;
    margin-bottom: 0;
  }
}
</style>
